import React from 'react';
import { Form, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formatarHora } from '../../../util/utils';
import { changeColor, changeColorConfirma } from '../../../util/agendaHelpers';
import AgendamentoActionsDropdown from './AgendamentoActionsDropdown';
import { triggerEvent } from '../constants';

const EMPTY_ACTIONS = {};

const AgendamentoRow = React.memo(
  ({ agenda, codAgenda, actions = EMPTY_ACTIONS }) => {
    const { preencherFormulario, handleAtividades } = actions;

    return (
      <tr
        style={changeColor(agenda)}
        onClick={() => preencherFormulario(agenda)}
        className={codAgenda === agenda.CODAGENDA ? 'table-success' : ''}
      >
        <td>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip id="a-radio">Atividades</Tooltip>}
          >
            <Form.Check
              type="radio"
              defaultChecked
              onClick={() => handleAtividades(agenda)}
            />
          </OverlayTrigger>
        </td>
        <td className="m-0 p-0">{formatarHora(agenda.HORARIO)}</td>
        <td className="m-0 p-0">{agenda.NOMEPAC}</td>
        <td className="m-0 p-0">{agenda.PROCEDIMENTO}</td>
        <td className="m-0 p-0">{agenda.CONVENIO}</td>
        <td className="m-0 p-0">{agenda.ATIVIDADE}</td>
        <td className="m-0 p-0">{agenda.SITUACAO}</td>
        <td className="m-0 p-0">{agenda.CELULARPAC}</td>
        <td className="m-0 p-0">{agenda.OBSERVACAO}</td>
        <td className="m-0 p-0">
          {' '}
          <Badge pill style={changeColorConfirma(agenda)}>
            {agenda.STATUSCONFIRMA}
          </Badge>
        </td>
        <td className="m-0 p-0">{agenda.HORAAGENDA}</td>
        <td className="m-0 p-0" onClick={e => e.stopPropagation()}>
          <AgendamentoActionsDropdown agenda={agenda} {...actions} />
        </td>
      </tr>
    );
  }
);

AgendamentoRow.displayName = 'AgendamentoRow';

export default AgendamentoRow;
